import type { OMSView } from '../OMSView';

export interface OMSFormTimingEntry {
  startTime: number;
  startPerf: number;
  view: OMSView;
}

let pendingTiming: OMSFormTimingEntry | null = null;

export const startOMSFormTiming = (view: OMSView): void => {
  pendingTiming = { startTime: Date.now(), startPerf: performance.now(), view };
};

export const consumeOMSFormTiming = (): OMSFormTimingEntry | null => {
  const timing = pendingTiming;
  pendingTiming = null;
  return timing;
};
